import { render, staticRenderFns } from "./TransboundaryRecord.vue?vue&type=template&id=2f79d0b4&scoped=true"
import script from "./TransboundaryRecord.vue?vue&type=script&lang=js"
export * from "./TransboundaryRecord.vue?vue&type=script&lang=js"
import style0 from "./TransboundaryRecord.vue?vue&type=style&index=0&id=2f79d0b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f79d0b4",
  null
  
)

export default component.exports